const carouselData = [
  {
    id: 1,
    title: "1-Day Mysore Explorer",
    description: "Mysore Palace, Zoo, St. Philomena's Church",
    amount: "₹1,200",
    image: "/assets/images/mysore.jpg",
    pick_up: "Mysore bus stand at 6.00 am",
    drop : "Mysore bus stand at 8.00 pm"
  },
  {
    id: 2,
    title: "2-Day Cultural Tour",
    description:
      "Mysore Palace, Zoo, Srirangapatna, Ranganathittu",
    amount: "₹3,500",
    image: "/assets/images/temple.png",
    pick_up: "day 1 - Mysore bus stand at 6.00 am",
    drop : "day 2 - Mysore bus stand at 8.00 pm"
  },
  {
    id: 3,
    title: "3-Day Mysore + Coorg Escape",
    description:
      "Mysore Palace, Coorg, Abbey Falls, Raja’s Seat, Dubare Elephant Camp",
    amount: "₹6,500",
    image: "/assets/images/mysoreZoo.jpg",
    pick_up: "day 1 - Mysore bus stand at 6.00 am",
    drop : "day 3 - Mysore bus stand at 8.00 pm"
  },
];

export default carouselData;
